<template>
    <div>
        <el-form :inline="true" :model="form1" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item label="单品">
                <el-select v-model="form1.productId" multiple filterable>
                    <el-option
                            v-for="item in getProductList"
                            :key="item.proId"
                            :label="item.proName"
                            :value="item.proId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="促销">
                <el-select v-model="form1.promotionId" multiple filterable>
                    <el-option
                            v-for="item in getPromotionList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <el-button type="success" @click="handleAddProduct">添加产品</el-button>

            </el-form-item>

        </el-form>
        <el-form label-width="1px">
            <el-form-item>
                <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize"
                          v-loading="loading" width="180">
                    <el-table-column type="index" label="序号" width="50">
                    </el-table-column>
                    <!--                    <el-table-column prop="itemId"  label="产品Id">-->
                    <!--                    </el-table-column>-->
                    <el-table-column prop="itemName" label="产品名称">
                    </el-table-column>
                    <el-table-column prop="itemTypeName" label="产品类型" width="70">
                    </el-table-column>
                    <el-table-column prop="sequence" label="排序" width="90">
                        <template slot-scope="scope">
                            <el-input v-model=scope.row.sequence :max="999" :min="0"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="originPrice" label="原价" width="70">
                    </el-table-column>

                    <el-table-column prop="salePrice" label="销售价" width="190">
                        <template slot-scope="scope">
                            <el-input-number v-model=scope.row.salePrice :max=5000 :min=0.01></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="priceTag" label="阶梯销售价">
                    </el-table-column>
                    <el-table-column label="状态" width="100">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.status">
                                <el-option
                                        v-for="item in statuslist"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button type="danger" v-show="isEdit" size="mini"
                                           @click="saveActiveItem(scope.row)">保存
                                </el-button>
                                <el-button type="primary" size="mini" @click="editPriceList(scope.row)"
                                           class="header-btn">阶梯价格
                                </el-button>
                                <el-button type="warning" v-show="isEdit" size="mini"
                                           @click="deleteActiveItem(scope.row)">删除
                                </el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap" v-show="!showDialog">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="formInline.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline.recordsTotal">
                    </el-pagination>
                </div>
            </el-form-item>
        </el-form>
        <el-dialog title="添加/修改阶梯价格" :visible.sync="showDialog">
            <el-form label-width="10px">
                <el-table :data="priceList" stripe border center :size="GCONFIG.styleTableSize"
                          v-loading="loading" width="180">
                    <el-table-column type="index" label="序号" width="60">
                    </el-table-column>

                    <el-table-column prop="start" label="起始数量">
                        <template slot-scope="scope">
                            <el-input-number v-model=scope.row.start max="10000" min="1"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="start" label="结束数量">
                        <template slot-scope="scope">
                            <el-input-number v-model=scope.row.end max="10000" min="1"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="销售价">
                        <template slot-scope="scope">
                            <el-input-number v-model=scope.row.price max="5000" min="0.01"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="操作">
                        <template slot="header" slot-scope="scope">
                            操作
                            <el-button type="primary" size="mini" @click="addPrice()" class="header-btn">新建</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" @click="deleteActiveItemPrice(scope.row)"
                                       class="header-btn">删除

                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span>
            <el-button type="primary" size="mini" @click="saveActiveItemPriceList(priceList)" class="header-btn">
              保 存
            </el-button><span style="color: #e50011">点击保存后生效</span>
          </span>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getActiveItemList,
        deleteActiveItem,
        saveActiveItem,
        saveItemSalePriceList,
        setActiveItemStatus,
        getPromotionList,
        getProductListL,
        getGroupListL
    } from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    bindCode: this.$route.query.bindCode,
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                statuslist: [{id: 1, name: "有效"}, {id: 0, name: "无效"}],
                priceList: [],
                price: {"start": 1, "end": 1, "price": 0},
                list: [],
                activeItem: {},
                showDialog: false,
                loading: true,
                isEdit: true,
                form1: {productId: [], promotionId: []},
                getProductList: [],
                getPromotionList: [],
            }
        },
        //挂载时候执行
        mounted(){
            this.getList();
            getPromotionList().then((res) => {
                this.getPromotionList = res.data.value;
            });
            getProductListL().then((res) => {
                this.getProductList = res.data.value;
            })
        },
        computed: {},
        methods: {
            addPrice(){
                this.priceList.push({"start": 1, "end": 1, "price": 0});
            },
            deleteActiveItemPrice(row){
                this.removeAaary(this.priceList, row);
            },
            removeAaary(_arr, _obj) {
                let length = _arr.length;
                for (var i = 0; i < length; i++) {
                    if (_arr[i] === _obj) {
                        if (i === 0) {
                            _arr.shift(); //删除并返回数组的第一个元素
                            return _arr;
                        } else if (i === length - 1) {
                            _arr.pop();  //删除并返回数组的最后一个元素
                            return _arr;
                        } else {
                            _arr.splice(i, 1); //删除下标为i的元素
                            return _arr;
                        }
                    }
                }
            },
            handleAddProduct(){
                if (this.form1.productId == '' && this.form1.promotionId == '') {
                    this.$message({
                        showClose: true,
                        message: "请选择单品或促销",
                        type: 'error'
                    });
                    return;
                }
                let itemType = 1;
                if (this.form1.productId != '') {
                    itemType = 4;
                    let data = {
                        "bindCode": this.formInline.bindCode,
                        "itemId": JSON.stringify(this.form1.productId),
                        "itemType": itemType,
                        "sequence": 0,
                        "status": 1
                    };
                    this.saveActiveItem(data);
                }
                if (this.form1.promotionId != '') {
                    itemType = 1;
                    var data = {
                        "bindCode": this.formInline.bindCode,
                        "itemId": JSON.stringify(this.form1.promotionId),
                        "itemType": itemType,
                        "sequence": 0,
                        "status": 1
                    };
                    this.saveActiveItem(data);
                }
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            editPriceList(activeItem){
                var s = JSON.parse(activeItem.priceList);
                if (s != null && s != undefined) {
                    this.priceList = s;
                }
                this.activeItem = activeItem;
                this.showDialog = true;
            },
            getList(){
                this.loading = true
                getActiveItemList(this.formInline).then((res) => {
                    console.log(res);
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            saveActiveItem(data){
                this.loading = true;
                saveActiveItem(data).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getList();
                        this.showDialog = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveActiveItemPriceList(priceList){
                let activeItem = this.activeItem;
                this.loading = true;
                let data = {"id": activeItem.id, "priceList": (JSON.stringify(priceList))};
                saveItemSalePriceList(data).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getList();
                        this.showDialog = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            deleteActiveItem(data){
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deleteActiveItem(data).then((res) => {
                        this.loading = false;
                        if (res.data.status == 200) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.getList();
                            this.showDialog = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/active/activeProductList.vue